import React, { useState } from 'react';
import { Button } from './button';
import ScrollableClubCardModal from './ScrollableClubCardModal';

const ClubViewButton = ({ clubId, children, className, ...props }) => {
  const [showClubModal, setShowClubModal] = useState(false);

  return (
    <>
      <Button
        {...props}
        className={className}
        onClick={() => setShowClubModal(true)}
      >
        {children}
      </Button>
      
      <ScrollableClubCardModal
        clubId={clubId}
        isOpen={showClubModal}
        onClose={() => setShowClubModal(false)}
      />
    </>
  );
};

export default ClubViewButton;
